import { OrganisationDto } from '../../core/models/organisation-dto';
import { UnitOfMeasureDto } from '../../core/models/unit-of-measure-dto';

export interface GeneralAdminState {
  organisations: OrganisationDto[];
  unitOfMeasure: UnitOfMeasureDto[];
  currencies: string[];
}

export const initialStoreState: Partial<GeneralAdminState> = {
  organisations: [],
  unitOfMeasure: [],
  currencies: [],
};
